import { render, staticRenderFns } from "./PigMenu.vue?vue&type=template&id=27131692&scoped=true&lang=pug&"
import script from "./PigMenu.vue?vue&type=script&lang=js&"
export * from "./PigMenu.vue?vue&type=script&lang=js&"
import style0 from "./PigMenu.vue?vue&type=style&index=0&id=27131692&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27131692",
  null
  
)

export default component.exports